export const simpleAuthButtons: { authType: 'Kakao' | 'Naver'; iconImageSrc: string }[] = [
  {
    authType: 'Kakao',
    iconImageSrc: '/images/symbols/kakao-app.svg'
  },
  {
    authType: 'Naver',
    iconImageSrc: '/images/symbols/naver-app.svg'
  }
];

export const loginTypes = {
  KAKAO: {
    name: '카카오톡',
    icon: '/images/symbols/sns-circle-kakao.svg'
  },
  NAVER: {
    name: '네이버',
    icon: '/images/symbols/sns-circle-naver.svg'
  },
  APPLE: {
    name: '애플',
    icon: '/images/symbols/sns-circle-apple.svg'
  },
  TOSS: {
    name: '토스',
    icon: '/images/symbols/sns-circle-toss.svg'
  },
  EMAIL: {
    name: '이메일'
  }
};
